<button
  *ngIf="selectedCompanyId"
  (click)="navigateToCampaignBuilder()"
  class="m-2">
  Back to Campaign builder
</button>
<div class="thank-you-header-container p-0">
  <nav
    class="header-nav container max-container-width navbar navbar-expand-lg navbar-light w-100">
    <div
      class="header-inner d-flex justify-content-between align-items-center w-100">
      <img
        routerLink="/home"
        class="header-logo"
        src="./assets/talentmarket.logo.webp"
        alt="Talentmarket logo" />
      <div id="navbarNav">
      </div>
    </div>
  </nav>
</div>
<div class="container thank-you-page-container">
  <span [innerHTML]="getSafeHtml(thankYou.html)"></span>
</div>
